/**
 * Created by hernanherreros on 2019-05-03
 */

import * as React from 'react'
import CongressContext, { CongressContextInterface } from './CongressContext'
import { getCongress, getCongressStatus } from '../../requests/congress'
import { Request } from 'fetchboi'
import { Redirect, RouteComponentProps, withRouter } from 'react-router'
import styled from 'styled-components'
import NotFoundError from './NotFoundError'
import { disabledCongresses, getCongressAlias, getCongressSlug, isAlias } from '../../config/congress.config'
import { baseAPIRoot } from '../../config/index.config'
import DisabledMessage from './DisabledMessage'

interface Props extends RouteComponentProps<any> {
  loadingScreen?: React.ReactNode;
}

class CongressProvider extends React.Component<Props, CongressContextInterface> {
  constructor (props: Props) {
    super(props)

    this.state = {
      congress: undefined,
      isLoading: true,
      setCongress: this.setCongress,
      disabled: false,
      status: {
        ClosingMessage: '',
        ClosingStatementURL: '',
        Enabled: true
      }
    }
  }

  componentWillMount () {
    this.initCongress()
  }

  async initCongress () {
    const congressSlug: any = this.getCongressSlug()
    console.log('congressSulg', congressSlug)

    if (disabledCongresses.indexOf(congressSlug) > -1) {
      await this.setState({ disabled: true })
    }

    this.setState({ isLoading: true })

    try {
      const { disabled } = this.state
      if(!disabled && congressSlug !== 'veterinario-colchagua-2020' && congressSlug !== 'veterinario-cartagena-2020'){
        const status = await getCongressStatus({ CongressSlug: congressSlug})
        console.log('status', status.Data)

        this.setState({ status: status.Data})
        if(!status.Data.Enabled){
          this.setState({ disabled: true })
        }
      }

      console.log('congressSulg', congressSlug)
      const congress: any = await getCongress({ slug: congressSlug })

      this.setCongress(congress.Data)

      Request.setDefaultParams({ CongressSlug: congressSlug })
    } catch (e) {
      console.log('Could not recover congress:', e)
    }

    this.setState({ isLoading: false })
  }

  setCongress = (congress?: any) => {
    this.setState({ congress })
  }

  getCongressSlug = () => {
    return getCongressSlug(this.getProvidedCongressSlug())
  }

  getProvidedCongressSlug = () => {
    const { match } = this.props
    return match ? match.params.congressSlug : ''
  }

  render() {
    return (
      <CongressContext.Provider value={this.state}>
        {this.renderContent()}
      </CongressContext.Provider>
    )
  }

  renderContent () {
    const { isLoading, congress, disabled } = this.state
    const { children } = this.props

    if (isAlias(this.getProvidedCongressSlug())) {
      const url = window.location.pathname + window.location.search
      const congressAlias = getCongressAlias(this.getProvidedCongressSlug())
      return <Redirect to={url.replace('/forms', '').replace(this.getProvidedCongressSlug(), congressAlias)}/>
    }

    if (isLoading) {
      return this.renderLoading()
    } else if (disabled) {
      return this.renderDisabled()
    } else if (!isLoading && !congress) {
      return this.renderError()
    } else {
      return children
    }
  }

  renderDisabled () {
    const { congress, status } = this.state

    return <DisabledMessage congress={congress} message={status.ClosingMessage} url={status.ClosingStatementURL}/>
  }

  renderLoading () {
    const { loadingScreen } = this.props

    if (loadingScreen) {
      return loadingScreen
    } else {
      return (
        <div>Loading...</div>
      )
    }
  }

  renderError () {
    return <NotFoundError/>
  }
}

export default withRouter(CongressProvider)
